import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useState, useRef } from 'react';
import { useClickAway } from 'react-use';
import Dropdown, { Item as DropdownItem, Action as DropdownAction } from '@/components/lists/Dropdown';
import dropdownStyles from '@/components/lists/Dropdown/styles.module.scss';
import parseUserAnswer from '@/utils/reporting/parseUserAnswer';
import styles from './styles.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var DropdownIcon = function DropdownIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7071 0.292986C11.3166 -0.097538 10.6834 -0.097538 10.2929 0.292986L6 4.58588L1.70711 0.292986C1.31658 -0.0975381 0.683417 -0.0975381 0.292893 0.292986C-0.0976314 0.68351 -0.0976314 1.31668 0.292893 1.7072L6 7.41431L11.7071 1.7072C12.0976 1.31668 12.0976 0.68351 11.7071 0.292986Z",
      fill: "#12131A"
    })
  }));
};

DropdownIcon.defaultProps = {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const QuestionOptionsMenu = _ref => {
  let {
    className,
    forInput,
    question,
    onChange,
    options,
    disabled,
    parseSelectedValue = val => val,
    children
  } = _ref;
  const containerEl = useRef(null);
  const menuOptions = options.map(_ref2 => {
    let {
      value,
      content
    } = _ref2;
    return {
      value,
      label: content || value
    };
  }); // Prevent click events propagating
  // to the label hijacing focus on menu

  const preventClickPropagation = evt => {
    evt.stopPropagation();
    evt.preventDefault();
  }; // Published parsed answer


  const handleChange = option => {
    let inputEl;

    if (forInput && containerEl.current) {
      const currentContainerEl = containerEl.current;
      inputEl = currentContainerEl.querySelector(`[id="${forInput}"]`);
    }

    const value = parseSelectedValue(option.value);
    onChange(parseUserAnswer(question, value), inputEl);
  };

  if (!options.length) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: clsx(styles.container, className || ''),
      "data-question": question.id,
      onClick: preventClickPropagation,
      ref: containerEl,
      children: [/*#__PURE__*/_jsx(OpenButton, {
        children: children
      }), /*#__PURE__*/_jsx(Dropdown, {
        className: styles.dropdown,
        children: menuOptions.map((option, idx) => /*#__PURE__*/_jsx(DropdownItem, {
          className: styles.dropdownItem,
          children: /*#__PURE__*/_jsx(DropdownAction, {
            className: styles.dropdownAction,
            disabled: disabled,
            onClick: () => handleChange(option),
            children: /*#__PURE__*/_jsx("span", {
              className: styles.label,
              children: option.label
            })
          })
        }, `${option.label}-${idx}`))
      })]
    })
  });
};

const OpenButton = _ref3 => {
  let {
    className = '',
    onClick,
    children
  } = _ref3;
  const ref = useRef(null);
  const timeoutRef = useRef(null);
  const {
    0: isActive,
    1: setActive
  } = useState(false);
  useClickAway(ref, () => {
    if (!isActive) return;
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setActive(false), 200);
  });
  return /*#__PURE__*/_jsxs("div", {
    role: "button",
    ref: ref,
    onClick: e => {
      setActive(true);
      typeof onClick === 'function' && onClick(e);
    },
    className: clsx(styles.openButton, dropdownStyles['-trigger'], isActive ? dropdownStyles['-active'] : '', className),
    children: [children, /*#__PURE__*/_jsx(DropdownIcon, {
      className: styles.dropdownIcon
    })]
  });
};

export default QuestionOptionsMenu;